// @flow
import React from 'react';
import * as DOMPurify from 'dompurify';

import type { BlockType } from 'types/Directus';

type Props = {
  block: BlockType
};

function DirectusBlocks({ block }: Props) {
  switch (block.type) {
    case 'paragraph':
      return <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.data.text) }} />;

    case 'header':
      const { level } = block.data;
      if (level === 3) {
        return <h3 className="mb-2" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.data.text) }} />;
      } else if (level === 4) {
        return <h4 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.data.text) }} />;
      }
      break;

    default:
      return null;
  }

  return null;
}

export default DirectusBlocks;
